import React, { createContext, useContext, useState, ReactNode } from "react";

interface BannerContextType {
  bottomBannerHeight: number;
  setBottomBannerHeight: (height: number) => void;
}

const BannerContext = createContext<BannerContextType | undefined>(undefined);

export const BannerProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [bottomBannerHeight, setBottomBannerHeight] = useState<number>(0);

  return (
    <BannerContext.Provider
      value={{ bottomBannerHeight, setBottomBannerHeight }}
    >
      {children}
    </BannerContext.Provider>
  );
};

export const useBannerHeight = () => {
  const context = useContext(BannerContext);
  if (context === undefined) {
    throw new Error("useBannerHeight must be used within a BannerProvider");
  }
  return context;
};
